import { X } from "lucide-react";
import { useUi, type Tab } from "@/lib/store";
import { Button } from "@/components/ui/button";
import { SourcesPanel } from "@/features/records/SourcesPanel";
import { CommentsPanel } from "@/features/notes/CommentsPanel";
import { AssistantPanel } from "@/features/ai/AssistantPanel";

export function RightPanel({ tab }: { tab: Tab | null }) {
  const panel = useUi((s) => s.rightPanel);
  const setPanel = useUi((s) => s.setRightPanel);
  const titles = { sources: "Sources & links", comments: "Comments", assistant: "Assistant" } as const;
  if (!panel) return null;
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex items-center gap-2 border-b px-3 py-2">
        <h2 className="flex-1 text-sm font-semibold">{titles[panel]}</h2>
        <Button variant="ghost" size="icon-xs" aria-label="Close side panel" onClick={() => setPanel(null)}>
          <X />
        </Button>
      </div>
      <div className="thin-scroll min-h-0 flex-1 overflow-y-auto">
        {panel === "sources" && <SourcesPanel tab={tab} />}
        {panel === "comments" && <CommentsPanel tab={tab} />}
        {panel === "assistant" && <AssistantPanel tab={tab} />}
      </div>
    </div>
  );
}
